import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.75 2.5C10.75 2.08579 10.4142 1.75 10 1.75C9.58579 1.75 9.25 2.08579 9.25 2.5H10.75ZM10.75 13.3333V2.5H9.25V13.3333H10.75Z",
			fill: "#282E9A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1663 1.75C13.7521 1.75 13.4163 2.08579 13.4163 2.5C13.4163 2.91421 13.7521 3.25 14.1663 3.25V1.75ZM19.1663 2.5H19.9163C19.9163 2.08579 19.5806 1.75 19.1663 1.75V2.5ZM19.1663 17.5V18.25C19.5806 18.25 19.9163 17.9142 19.9163 17.5H19.1663ZM0.833008 17.5H0.0830078C0.0830078 17.9142 0.418794 18.25 0.833008 18.25L0.833008 17.5ZM0.833008 2.5V1.75C0.418794 1.75 0.0830078 2.08579 0.0830078 2.5H0.833008ZM5.83301 3.25C6.24722 3.25 6.58301 2.91421 6.58301 2.5C6.58301 2.08579 6.24722 1.75 5.83301 1.75V3.25ZM14.1663 3.25H19.1663V1.75H14.1663V3.25ZM18.4163 2.5V17.5H19.9163V2.5H18.4163ZM19.1663 16.75H0.833008V18.25H19.1663V16.75ZM1.58301 17.5V2.5H0.0830078V17.5H1.58301ZM0.833008 3.25H5.83301V1.75H0.833008V3.25Z",
			fill: "#282E9A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6967 9.69635C14.9896 9.40345 14.9896 8.92858 14.6967 8.63569C14.4038 8.34279 13.9289 8.34279 13.636 8.63569L14.6967 9.69635ZM9.99967 13.3327L9.46934 13.863L9.99967 14.3933L10.53 13.863L9.99967 13.3327ZM6.36334 8.63569C6.07044 8.34279 5.59557 8.34279 5.30268 8.63569C5.00978 8.92858 5.00978 9.40345 5.30268 9.69635L6.36334 8.63569ZM13.636 8.63569L9.46934 12.8024L10.53 13.863L14.6967 9.69635L13.636 8.63569ZM10.53 12.8024L6.36334 8.63569L5.30268 9.69635L9.46934 13.863L10.53 12.8024Z",
			fill: "#282E9A"
		})
	]
});
export default SvgDownload;
